export default () => {
  const container = document.querySelector('.js-woo-additional-products');
  if (!container) return;

  const trigger = container.querySelector('.js-woo-additional-products--trigger');
  const options = container.querySelectorAll('.js-woo-additional-product-option');
  const selection = container.querySelector('.js-woo-additional-product-selection');
  let selectionArray = [];

  trigger.addEventListener('click', e => {
    console.log('Clicked on product option: Additional product')

    if (container.classList.contains('active')) {
      container.classList.remove('active')
    } else {
      container.classList.add('active')
    }
  });

  [...options].forEach(option => {
    option.addEventListener('click', e => {
      const productId = option.dataset.id;
      console.log(`You selected product: ${productId}`);

      if (option && typeof option.classList !== 'undefined') {
        (option.classList.contains('active'))
          ? option.classList.remove('active')
          : option.classList.add('active');
      }

      (selectionArray.includes(productId))
        ? (selectionArray = selectionArray.filter(item => item !== productId))
        : (selectionArray.push(productId))

      selection.setAttribute('value', JSON.stringify(selectionArray))
    });
  })
};


// WEBPACK FOOTER //
// ./src/js/woocommerce/ProductAdditionalProducts.js